import React, { useEffect, useState } from 'react';
import columns from '../../../columns/ibApproved/pending';
import ibColumns from '../../../columns/ibApproved/IbAccept.js';
import TableWithSkeleton from '../../../components/global/table/TableWithSkeleton';
import ModalComponent from '../../../components/global/modal/ModalComponent';
import Pagination from "../../../components/global/pagination/Pagination.jsx";
import { GetAllAccountTypeApi, GetAllibApi, GetAllIBByIdApi, IBMultiLevelRejectApproveApi, IBRejectApproveApi } from "../../../api/request/ibapproved.js";
import moment from "moment";
import { Form, Spin, Input, Switch, Button } from 'antd';
import { PlusOutlined, MinusOutlined } from "@ant-design/icons";
import LoadableButton from '../../../components/buttons/LoadableButton.jsx';
import toast from 'react-hot-toast';
import Eye from '../../../assets/Eye.jsx';
import ConfirmationModal from '../../../components/global/modal/ConfirmationModal.jsx';
import MySegmented from '../../../components/segmented/Segmented.jsx';
import EditWithRect from '../../../assets/EditWithRect.jsx';
import UserAvatar from '../../../components/global/avtar/UserAvatar.jsx';
import { useNavigate } from 'react-router-dom';
import useModulePermissions from '../../../hooks/useModulePermissions.jsx';
const { TextArea } = Input;

export default function IbPending({ dates }) {

  const ibManagerPermissions = useModulePermissions('ib_manager');
  const canAcceptReject = !!ibManagerPermissions.accept_reject;

  const [form] = Form.useForm();
  const [rejectForm] = Form.useForm();
  const primaryColor = (getComputedStyle(document.documentElement).getPropertyValue('--theme'))?.trim();
  const [isOpenAcceptModal, setIsOpenAcceptModal] = useState(false);
  const [isOpenRejectModal, setIsOpenRejectModal] = useState(false);
  const [isLoadingIBDetails, setIsLoadingIBDetails] = useState(false);
  const [pageSize, setPageSize] = useState(10);
  const [page, setPage] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [isPending, setIsPending] = useState(false);
  const [totalRecord, setTotalRecord] = useState(0);
  const [data, setData] = useState([]);
  const [ibdata, setIbData] = useState([]);
  const [selectedIBId, setSelectedIBId] = useState('');
  const [iBDetails, setIBDetails] = useState({});
  const [isLoadingAccounts, setIsLoadingAccounts] = useState(false);
  const [selectedId, setSelectedId] = useState('');
  const [accounts, setAccounts] = useState([]);
  const [isLoadingSubmit, setIsLoadingSubmit] = useState(false);
  const [selectedAccounts, setSelectedAccounts] = useState([]);
  const [selectedIndex, setSelectedIndex] = useState([]);
  const [initialValues, setInitialValues] = useState({ comment: '' });
  const [sorter, setSorter] = useState({ SortBy: 'requestDate', SortOrder: '' });
  const [isAcceptConfirmModal, setIsAcceptConfirmModal] = useState(false);
  const [isIbLevelTypeOne, setIsIbLevelTypeOne] = useState(false);
  const [isMultiLevel, setIsMultiLevel] = useState(false);
  const [segmentValue, setSegmentValue] = useState(null);
  const [tempData, setTempData] = useState([]);
  const [groupList, setGroupList] = useState([]);
  const navigate = useNavigate();
  const getAllIB = async () => {
    try {
      let params = {
        PageNumber: page,
        PageSize: pageSize,
        SearchText: dates,
        FilterText: "Pending",
        ...sorter
      }
      setIsLoading(true);
      const { data } = await GetAllibApi(new URLSearchParams(params).toString());
      if (data?.success) {
        setData(
          data?.data?.map((item) => {
            return {
              ...item,
              name: (<UserAvatar data={{ name: `${item?.firstName} ${item?.lastName}`, email: item?.email }} />),
              requestDate: (item?.requestDate ? moment(item?.requestDate).format("DD-MM-YYYY, hh:mm A") : null),
              action: (
                <div className="flex">
                  <button type="button" onClick={() => { setSelectedIBId(item?.userId); setIsPending(true) }}><Eye /></button>
                  <button className="mr-3 ml-3" onClick={() => navigate(`/ib_details/pending/${item?.userId}`)} ><img src="assets/icons/accept_icon.svg" className='min-w-6 max-w-6' alt="icon" /></button>
                  {/* <button className="mr-3 ml-3" onClick={() => openAcceptModal(item?.userId)} ><img src="assets/icons/accept_icon.svg" className='min-w-6 max-w-6' alt="icon" /></button> */}
                  <button onClick={() => openRejectModal(item?.userId)}><img src="assets/icons/delete_icon.svg" alt="icon" className='min-w-6 max-w-6' /></button>
                </div>
              ),
            };
          })
        );
        setTotalRecord(data?.totalRecords);
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  }

  const getAccountTypes = async (id) => {
    try {
      setIsLoadingAccounts(true);
      let apiParams = {
        UserId: id,
        AccountType: true
      }
      const { data } = await GetAllAccountTypeApi(new URLSearchParams(apiParams).toString());
      if (data?.success) {
        setAccounts(data?.data);
        setIsIbLevelTypeOne(data?.data?.[0]?.ibLevelType === 1);
      }
      setIsLoadingAccounts(false);
    } catch (error) {
      setIsLoadingAccounts(false);
    }
  }
  const handleTableChange = (pagination, filters, sorter) => {
    if (sorter?.order) {
      setSorter({ SortBy: sorter?.field, SortOrder: sorter?.order });
    } else {
      setSorter({ SortBy: 'requestDate', SortOrder: '' });
    }
  };

  const getIBById = async () => {
    try {
      setIsLoadingIBDetails(true);
      const { data } = await GetAllIBByIdApi(selectedIBId);
      setIBDetails(data?.data);
      setIsLoadingIBDetails(false);
    } catch (error) {
      setIsLoadingIBDetails(false);
    }
  }

  const openAcceptModal = (id) => {
    setSelectedId(id);
    setIsOpenAcceptModal(true);
    getAccountTypes(id);
  }

  const openRejectModal = (id) => {
    setSelectedId(id);
    setIsOpenRejectModal(true);
  }

  const accountSelectionHandler = () => {
    setIsLoading(true);
    let array = [];
    selectedAccounts?.map((account, index) => (
      array.push({ no: index + 1, planName: account?.planName, maxCommission: account?.maxCommission, commisionamount: '', groupId: account?.groupId, groupName: account?.groupName })
    ));
    setIbData(array?.map((item) => {
      return {
        ...item,
        commisionamount: (
          <Form.Item name={`commission-${item.no}`} rules={[
            { required: true, message: 'Please enter commission.' },
            { validator: (_, value) => value > item.maxCommission ? Promise.reject(new Error(`Maximum commission should be ${item.maxCommission}.`)) : Promise.resolve(), },
          ]} >
            <Input
              prefix={<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill={primaryColor} class="size-6">
                <path d="M10.464 8.746c.227-.18.497-.311.786-.394v2.795a2.252 2.252 0 0 1-.786-.393c-.394-.313-.546-.681-.546-1.004 0-.323.152-.691.546-1.004ZM12.75 15.662v-2.824c.347.085.664.228.921.421.427.32.579.686.579.991 0 .305-.152.671-.579.991a2.534 2.534 0 0 1-.921.42Z" />
                <path fill-rule="evenodd" d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25ZM12.75 6a.75.75 0 0 0-1.5 0v.816a3.836 3.836 0 0 0-1.72.756c-.712.566-1.112 1.35-1.112 2.178 0 .829.4 1.612 1.113 2.178.502.4 1.102.647 1.719.756v2.978a2.536 2.536 0 0 1-.921-.421l-.879-.66a.75.75 0 0 0-.9 1.2l.879.66c.533.4 1.169.645 1.821.75V18a.75.75 0 0 0 1.5 0v-.81a4.124 4.124 0 0 0 1.821-.749c.745-.559 1.179-1.344 1.179-2.191 0-.847-.434-1.632-1.179-2.191a4.122 4.122 0 0 0-1.821-.75V8.354c.29.082.559.213.786.393l.415.33a.75.75 0 0 0 .933-1.175l-.415-.33a3.836 3.836 0 0 0-1.719-.755V6Z" clip-rule="evenodd" />
              </svg>}
              type='number'
              className='py-2'
              placeholder='Enter commission'
            />
          </Form.Item>
        )
      };
    }));
    setIsLoading(false);
  }

  const addAccount = (account, index) => {
    const updatePlansArray = (plansArray, newPlan) => {
      const index = plansArray.findIndex(plan => plan.planId === newPlan.planId);
      if (index !== -1) {
        plansArray.splice(index, 1);
      } else {
        plansArray.push(newPlan);
      }
      return plansArray;
    }
    setGroupList(prev => {
      if (prev.includes(account.groupId)) {
        return prev.filter(id => id !== account.groupId);
      } else {
        return [...prev, account.groupId];
      }
    });
    setSelectedIndex((prevNumbers) => {
      if (prevNumbers.includes(index)) {
        return prevNumbers.filter((n) => n !== index);
      } else {
        return [...prevNumbers, index];
      }
    });
    setSelectedAccounts(updatePlansArray(selectedAccounts, account));
  }


  const requestRejectHandler = async (values) => {
    try {
      setIsLoadingSubmit(true);
      let apiParams = {
        ...values,
        userId: selectedId,
        isApproved: false,
        isNewRecord: false
      }
      const { data } = await IBRejectApproveApi(apiParams);
      if (data?.success) {
        toast.success(data?.message);
        rejectForm.resetFields();
        getAllIB();
        setIsOpenRejectModal(false);
      }
      setIsLoadingSubmit(false);
    } catch (error) {
      if (error?.response?.data?.error?.message) {
        toast.error(error?.response?.data?.error?.message);
      }
      setIsLoadingSubmit(false);
    }
  }

  const editHandler = () => {
    setIbData([]);
    form.resetFields();
  }

  const ibLevelType2Handler = async () => {
    try {
      setIsLoadingSubmit(true);
      let apiParams = {
        userId: selectedId,
        comment: 'Approved',
        isApproved: true,
        groupIds: groupList
      }
      const { data } = await IBMultiLevelRejectApproveApi(apiParams);
      if (data?.success) {
        toast.success(data?.message);
        getAllIB();
        setIsAcceptConfirmModal(false);
        setIsOpenAcceptModal(false);
        setSelectedAccounts([]);
        setGroupList([]);
      }
      setIsLoadingSubmit(false);
    } catch (error) {
      if (error?.response?.data?.error?.message) {
        toast.error(error?.response?.data?.error?.message);
      }
      setIsLoadingSubmit(false);
    }
  }

  useEffect(() => {
    getAllIB();
  }, [page, pageSize, sorter, dates]);

  useEffect(() => {
    setPage(1);
  }, [dates]);

  useEffect(() => {
    if (selectedIBId) {
      getIBById();
    }
  }, [selectedIBId]);

  useEffect(() => {
    if (isOpenAcceptModal) {
      setSelectedAccounts([]);
      setSelectedIndex([]);
      setIbData([]);
      setIsMultiLevel(false);
      setGroupList([]);
      form.resetFields();
    }
  }, [isOpenAcceptModal]);


  useEffect(() => {
    setInitialValues({ comment: '' });
    rejectForm.resetFields();
  }, [isOpenRejectModal]);


  const segmentedOptions = ibdata?.map((item) => ({
    label: item?.planName,
    value: item?.planName,
  }));

  useEffect(() => {
    if (segmentedOptions?.length > 0 && !segmentValue) {
      setSegmentValue(segmentedOptions[0]?.value);
    }
  }, [segmentedOptions]);

  useEffect(() => {
    if (ibdata?.length > 0) {
      const formattedData = ibdata?.map((item) => ({
        ...item,
        commission: item?.commission || { "level 0": '' },
      }));
      setTempData(formattedData);
    }
  }, [ibdata]);



  const selectedPlan = tempData?.find(item => item?.planName === segmentValue);
  const getTotalCommission = (commission) => {
    return Object.values(commission).reduce((sum, value) => sum + (parseFloat(value) || 0), 0);
  };

  const handleCommissionChange = (level, value) => {
    setTempData((prevData) =>
      prevData.map((plan) =>
        plan.planName === segmentValue
          ? {
            ...plan,
            commission: {
              ...plan.commission,
              [`level ${level}`]: value === '' ? '' : parseFloat(value),
            },
          }
          : plan
      )
    );
  };

  const handleAddLevel = () => {
    setTempData((prevData) =>
      prevData.map((plan) =>
        plan.planName === segmentValue
          ? {
            ...plan,
            commission: {
              ...plan.commission,
              [`level ${Object.keys(plan.commission).length}`]: "",
            },
          }
          : plan
      )
    );
  };

  const handleRemoveLevel = () => {
    setTempData((prevData) =>
      prevData.map((plan) => {
        if (plan.planName === segmentValue) {
          const levels = Object.keys(plan.commission);
          if (levels.length > 1) {
            const lastLevel = `level ${levels.length - 1}`;
            const newCommission = { ...plan.commission };
            delete newCommission[lastLevel];
            form.setFieldsValue({
              commission: {
                ...form.getFieldValue("commission"),
                [plan.planName]: {
                  ...form.getFieldValue(["commission", plan.planName]),
                  [`level_${levels.length - 1}`]: "",
                },
              },
            });
            return { ...plan, commission: newCommission };
          }
        }
        return plan;
      })
    );
  };

  const onFinish = async (values) => {
    let errorMessage = null;
    let multiLevelCommissions = [];
    let commission = [];
    let groupId = [];

    if (isMultiLevel) {
      tempData?.map((item) => {
        Object.keys(item?.commission)?.forEach((level) => {
          if (item.commission[level] === '') {
            errorMessage = 'Commission field is empty';
            return;
          }
          const numericValue = parseFloat(item?.commission[level]) || 0;
          const levelNumber = parseInt(level?.split(' ')[1], 10);
          const totalCommission = getTotalCommission(item.commission) - (item.commission[`level ${levelNumber}`] || 0) + numericValue;
          if (totalCommission > selectedPlan.maxCommission) {
            errorMessage = 'Total commission cannot exceed';
            return;
          }
          let group = multiLevelCommissions?.find(g => g?.groupId === item?.groupId);
          if (!group) {
            group = { groupId: item.groupId, levels: [] };
            multiLevelCommissions?.push(group);
          }
          group?.levels?.push({ level: levelNumber + 1, commissionAmount: numericValue });
        });
      });
    }
    else {
      ibdata?.map((item, index) => (
        commission?.push(values?.[`commission-${index + 1}`]),
        groupId?.push(item?.groupId)
      ))
    }
    if (errorMessage) {
      toast.error(errorMessage);
      return;
    }
    setIsLoadingSubmit(true);
    try {
      setIsLoadingSubmit(true);
      let apiParams = {
        userId: selectedId,
        comment: 'Approved',
        isApproved: true,
        isNewRecord: true,
        commission: isMultiLevel ? [] : commission,
        groupId: isMultiLevel ? [] : groupId,
        commissionType: isMultiLevel ? 2 : 1,
        multiLevelCommissions: isMultiLevel ? multiLevelCommissions : [],
      }
      const { data } = await IBRejectApproveApi(apiParams);
      if (data?.success) {
        toast.success(data?.message);
        setSelectedAccounts([]);
        setSelectedIndex([]);
        setData([]);
        form.resetFields();
        getAllIB();
        setIsOpenAcceptModal(false);
      }
      setIsLoadingSubmit(false);
    } catch (error) {
      if (error?.response?.data?.error?.message) {
        toast.error(error?.response?.data?.error?.message);
      }
      setIsLoadingSubmit(false);
    }
  };


  return (
    <>
      {/* pending table */}

      <div className="my-6">
        <div className="border border-gray-200 rounded-xl overflow-hidden bg-white">
          <TableWithSkeleton
            columns={columns}
            data={data}
            loading={isLoading}
            onChange={handleTableChange}
            hiddenColumns={!canAcceptReject ? ["Actions"] : []}
            page={page}
            pageSize={pageSize}
            index={true}
          />
        </div>
        <Pagination total={totalRecord} pageSize={pageSize} setPageSize={setPageSize} page={page} setPage={setPage} />
      </div>

      {/* pending modal */}
      <ModalComponent isOpen={isPending} setIsOpen={setIsPending} title='IB Details' width={1300}>
        {
          isLoadingIBDetails ? (
            <div className="flex justify-center flex-col my-[5%]">
              <Spin size="large" />
              <p className="primary text-center mt-2">Loading...</p>

            </div>
          ) : (
            <div className='p-5'>
              <div className='grid lg:grid-cols-4 md:grid-cols-3 sm:grid-cols-2 gap-10 '>
                <div>
                  <p className='text-description font-normal '>First Name</p>
                  <p className='text-description primary font-semibold  mt-2'>{iBDetails?.firstName}</p>
                </div>
                <div>
                  <p className='text-description font-normal '>Last Name</p>
                  <p className='text-description primary font-semibold  mt-2'>{iBDetails?.lastName}</p>
                </div>
                <div>
                  <p className='text-description font-normal '>Mobile No.</p>
                  <p className='text-description primary font-semibold  mt-2'>{iBDetails?.phoneNo}</p>
                </div>
                <div>
                  <p className='text-description font-normal '>Email</p>
                  <p className='text-description primary font-semibold  mt-2'>{iBDetails?.email}</p>
                </div>
                <div>
                  <p className='text-description font-normal '>Request Time</p>
                  <p className='text-description primary font-semibold  mt-2'>{iBDetails?.requestDate ? moment(iBDetails?.requestDate).format('DD-MM-YYYY, hh:mm A') : '--'}</p>
                </div>
              </div>
            </div>
          )
        }
      </ModalComponent>

      {/* Accept ib request modal */}
      <ModalComponent isOpen={isOpenAcceptModal} setIsOpen={setIsOpenAcceptModal} title={'Accept IB Request'} width={1000}>
        {
          isLoadingAccounts ? (
            <div className="flex justify-center flex-col my-[10%]">
              <Spin size="large" />
              <p className="primary text-center mt-2">Loading...</p>
            </div>
          ) : (
            <div>
              {ibdata?.length > 0 ? (
                <div>
                  <div className='flex justify-end'>
                    <div onClick={editHandler} className={`${isMultiLevel ? 'hidden' : 'block'} cursor-pointer`}><EditWithRect /></div>
                  </div>
                  <div className="my-6">
                    <Form form={form} onFinish={onFinish} requiredMark={false} layout='vertical'>
                      {data?.length > 0 && (
                        isMultiLevel ?
                          <>
                            <div className="flex items-center justify-between">
                              <div>
                                <MySegmented options={segmentedOptions} value={segmentValue} setValue={setSegmentValue} />
                              </div>
                              <div className='flex items-center gap-4'>
                                <Button type="button" icon={<PlusOutlined />} onClick={handleAddLevel} size="medium" className='bg-primary text-white'>Level</Button>
                                <Button type="button" icon={<MinusOutlined />} onClick={handleRemoveLevel}
                                  disabled={Object.keys(selectedPlan?.commission || {}).length <= 1}
                                  size="medium"
                                  className="bg-primary text-white disabled:opacity-70"
                                >
                                  Level
                                </Button>
                                <div onClick={editHandler} className={`cursor-pointer`}><EditWithRect /></div>
                              </div>
                            </div>
                            <div className='flex items-center gap-3 mt-5 text-description'>
                              <p className='text-[#2F2B3D]'>Maximum Commission </p>
                              <p className='text-[#e47655] font-semibold'>{selectedPlan?.maxCommission}</p>
                            </div>
                            <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mt-6'>
                              {selectedPlan &&
                                Object.keys(selectedPlan.commission).map((level, index) => {
                                  const prevLevel = `level ${index - 1}`;
                                  const isDisabled = index > 0 && !selectedPlan.commission[prevLevel];
                                  return (
                                    <Form.Item
                                      label={`Level ${index + 1}`}
                                      key={index}
                                      name={['commission', selectedPlan.planName, `level_${index}`]}
                                      rules={[
                                        { required: true, message: `Level ${index + 1} commission is required.` },
                                        {
                                          validator: (_, value) => {
                                            const numericValue = parseFloat(value);
                                            const totalCommission =
                                              getTotalCommission(selectedPlan.commission) - (selectedPlan.commission[`level ${index}`] || 0) + numericValue;
                                            if (totalCommission > selectedPlan.maxCommission) {
                                              return Promise.reject(`Total commission cannot exceed ${selectedPlan.maxCommission}.`);
                                            }
                                            return Promise.resolve();
                                          },
                                        },
                                      ]}
                                    >
                                      <Input
                                        type="number"
                                        min="0"
                                        step="any"
                                        pattern="[0-9]*[.]?[0-9]*"
                                        disabled={isDisabled}
                                        value={selectedPlan.commission[level] || ""}
                                        onChange={(e) => handleCommissionChange(index, e.target.value)}
                                        placeholder={`Enter Level ${index + 1} commission`}
                                      />
                                    </Form.Item>
                                  );
                                })}
                            </div>
                          </> :
                          <>
                            <TableWithSkeleton data={ibdata} columns={ibColumns} />
                          </>
                      )}
                      {data?.length > 0 && (
                        <div className='mt-6 mx-6 flex justify-end'>
                          <Form.Item>
                            <div className='flex items-center justify-end gap-5'>
                              <button disabled={isLoadingSubmit} type='button' onClick={() => setIsOpenAcceptModal(false)} className='bg-secondary text-sm text-white font-semibold px-6 py-2 rounded-lg themeSecondaryHover duration-500'>Cancel</button>
                              <LoadableButton
                                type='submit'
                                className='bg-primary text-sm text-white font-semibold px-6 py-2 rounded-lg themeHover duration-500'
                                lable='Approve'
                                loadingLable='Approving request...'
                                isLoading={isLoadingSubmit}
                              />
                            </div>
                          </Form.Item>
                        </div>
                      )}
                    </Form>
                  </div>
                </div>
              ) : (
                <div>
                  <div className='grid grid-cols-3 gap-3'>
                    {accounts?.map((account, index) => (
                      <div key={index}>
                        <div
                          className={`border rounded-md p-1 cursor-pointer
                            ${selectedIndex.includes(index) ? "border-primary" : "border-lightPrimary"}`}
                          onClick={() => addAccount(account, index)}>
                          <p className='text-center font-semibold text-lg'>{account?.planName}</p>
                          <p className='text-center text-sm'>{account?.groupName}</p>
                        </div>
                      </div>
                    ))}
                  </div>
                  <div className={`flex ${isIbLevelTypeOne ? 'justify-between' : 'justify-center'} items-center mt-8 px-2`}>
                    {isIbLevelTypeOne && (
                      <div className="flex items-center gap-2">
                        <Switch checkedChildren="On" unCheckedChildren="Off" checked={isMultiLevel} onChange={(checked) => setIsMultiLevel(checked)} className='scale-105' />
                        <p className='text-description'>Enable Multi-Level</p>
                      </div>
                    )}
                    <button onClick={() => {
                      if (isIbLevelTypeOne) {
                        accountSelectionHandler();
                      } else {
                        if (groupList?.length > 0) {
                          setIsOpenAcceptModal(false);
                          setIsAcceptConfirmModal(true);
                        }
                      }
                    }}
                      className='bg-primary text-sm text-white font-semibold px-6 py-2 rounded-lg themeHover duration-500'
                    >  {isIbLevelTypeOne ? 'Proceed' : 'Accept'}
                    </button>
                  </div>
                </div>
              )}
            </div>
          )
        }
      </ModalComponent>

      {/* Reject ib request modal */}
      <ModalComponent isOpen={isOpenRejectModal} setIsOpen={setIsOpenRejectModal} title={'Reject IB Request'} width={600} >
        <Form form={rejectForm} initialValues={initialValues} onFinish={requestRejectHandler}>
          <label className='text-description text-[#2F2B3DCC] font-medium'>Reason of rejection</label>
          <Form.Item name="comment" rules={[{ required: true, message: 'Please enter comment.' }]}>
            <TextArea rows={4} placeholder='Describe reason...' />
          </Form.Item>
          <div className='flex items-center justify-end gap-5 mt-5'>
            <button disabled={isLoadingSubmit} type='button' onClick={() => setIsOpenRejectModal(false)} className='bg-secondary text-sm text-white font-semibold px-6 py-2 rounded-lg themeSecondaryHover duration-500'>Cancel</button>
            <LoadableButton
              type='submit'
              className='bg-primary text-sm text-white font-semibold px-6 py-2 rounded-lg themeHover duration-500'
              lable='Reject'
              loadingLable='Rejecting request...'
              isLoading={isLoadingSubmit}
            />
          </div>
        </Form>
      </ModalComponent>

      {/* ibLevelType1 accept modal */}
      <ConfirmationModal
        isOpen={isAcceptConfirmModal}
        setIsOpen={setIsAcceptConfirmModal}
        type='success'
        message='Are you sure you want to accept this request?'
        onConfirm={ibLevelType2Handler}
        isLoading={isLoadingSubmit}
        loadingLabel='Accepting request...'
      />
    </>
  )
}
